module.exports = __webpack_public_path__ + "img/2-01.cd1f8030.png";